import { Outlet, createFileRoute, redirect } from '@tanstack/react-router';
import { api } from '~/lib/api';

// Layout for authenticated routes. The loader runs before children render and
// will redirect to /login if there's no session.
export const Route = createFileRoute('/_authed')({
  beforeLoad: async () => {
    const me = await api.me().catch(() => ({ user: null }));
    if (!me.user) throw redirect({ to: '/login' });
    return { user: me.user };
  },
  component: () => <Outlet />,
});
